export enum Endpoint {
  GET_CHAT_HISTORY = 'assistant/chatHistory'
}
